var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"textArea",staticClass:"edit-div",attrs:{"contenteditable":_vm.canEdit},domProps:{"innerHTML":_vm._s(_vm.innerText)},on:{"focus":_vm.scrollTop,"blur":_vm.lock,"input":_vm.changeText}})}
var staticRenderFns = []

export { render, staticRenderFns }